export default __webpack_public_path__ + "static/media/ccsi.f70eba7b.jpeg";